export const homePage = {
  now_on: 'Now on {{marketplaceName}}',
  coming_soon: 'Coming Soon!',
}
